import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NavbarSettings from "../../components/settingsComponent/navbarSettings";
import ToastAlert from "../../components/common/ToastAlert";
import ProfileSection from "../../components/settingsComponent/profileSection";
import CronSection from "../../components/settingsComponent/cronSection";
import DomainNameSection from "../../components/settingsComponent/domainNameSection";

const Settings = () => {
  const location = useLocation();
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (location.state?.toastMessage) {
      setToast({
        message: location.state.toastMessage,
        type: location.state.toastType || "success"
      });
      
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div className="bg-bg-main min-h-screen">
      <NavbarSettings />
      <div className="px-4 sm:px-8 md:px-[10%] lg:px-[15%]">
        <ProfileSection />
        <CronSection />
        <DomainNameSection />
      </div>
      
      {toast && (
        <ToastAlert 
          message={toast.message} 
          type={toast.type} 
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
};

export default Settings;